import { render, staticRenderFns } from "./PostComposer.vue?vue&type=template&id=9482a776&scoped=true&"
import script from "./PostComposer.vue?vue&type=script&lang=js&"
export * from "./PostComposer.vue?vue&type=script&lang=js&"
import style0 from "./PostComposer.vue?vue&type=style&index=0&id=9482a776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9482a776",
  null
  
)

export default component.exports